import { useTranslations } from "next-intl";
import { usePrice } from "@hooks/use-prices";
import { useFormatDate } from "@hooks/use-format-date";
import { standardDeliveryDaysCount } from "@utils/deliveryDelays";
import DeliveryOptionCard from "./DeliveryOptionCard";

function ExpressDeliveryChoice({
  shippingCountry, priceInCents, standardDeliveryDate, expressDeliveryDate, selected, onSelect,
}) {
  const t = useTranslations("common");
  const price = usePrice();
  const formatDate = useFormatDate();

  const standardSubtitle = standardDeliveryDate
    ? t("drawer.modal_rtc.validate.addresses.preparation_delay_date", { date: formatDate(standardDeliveryDate) })
    : t("drawer.modal_rtc.validate.addresses.preparation_delay", {
      daysCount: standardDeliveryDaysCount(shippingCountry),
    });

  const expressSubtitle = expressDeliveryDate
    ? t("drawer.modal_rtc.validate.addresses.express_delivery.express_sublabel_date", { date: formatDate(expressDeliveryDate) })
    : t("drawer.modal_rtc.validate.addresses.express_delivery.express_sublabel");

  return (
    <div className="mt-2 d-flex flex-column gap-2">
      <DeliveryOptionCard
        title={t("drawer.modal_rtc.validate.addresses.express_delivery.standard_label")}
        subtitle={standardSubtitle}
        selected={!selected}
        onClick={() => onSelect(false)}
      />
      <DeliveryOptionCard
        title={t("drawer.modal_rtc.validate.addresses.express_delivery.express_label", {
          price: price(priceInCents),
        })}
        subtitle={expressSubtitle}
        selected={selected}
        onClick={() => onSelect(true)}
      />
    </div>
  );
}

export default ExpressDeliveryChoice;
